import { render, staticRenderFns } from "./SelectionWarningBanner.vue?vue&type=template&id=ec32eb3a&scoped=true"
import script from "./SelectionWarningBanner.vue?vue&type=script&lang=js"
export * from "./SelectionWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./SelectionWarningBanner.vue?vue&type=style&index=0&id=ec32eb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec32eb3a",
  null
  
)

export default component.exports